export const IRI_STARTS_WITH_MATCHER = /^[A-Za-z]/i;

// eslint-disable-next-line no-control-regex
export const INVALID_IRI_MATCHER = /[\x00-\x20<>\\"{}|^`]/gi;
